import React from 'react';
import * as PropTypes from 'prop-types';
import cn from 'classnames';
import { CSSTransition } from 'react-transition-group';
/**/
import { Loader } from './Loader';

const FullPageLoaderContainer = (props) => {
  return (
    <CSSTransition
      classNames="full-page-loader-container"
      in={props.isOpen}
      mountOnEnter={true}
      unmountOnExit={true}
      appear={true}
      timeout={200}
    >
      <div className={cn('full-page-loader-container', props.className)}>
        <Loader className={'full-page-loader-container__loader'} />
      </div>
    </CSSTransition>
  );
};

FullPageLoaderContainer.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  className: PropTypes.string,
};

export { FullPageLoaderContainer };
